import { isWorkerAvailableForShift } from "../../utils/weeklyAvailability";

export function buildSmartMatch(worker, shift, { availabilityRanking = false, facility } = {}) {
  let score = 0;
  const reasons = [];

  // ...existing scoring...

  if (worker.hasTransportation) {
    score += 10;
    reasons.push("Reliable transportation");
  }

  if (Number(worker.reliabilityScore || 100) >= 95) {
    reasons.push("Excellent reliability");
  }

  // Opt in only for selected-shift recommendations; assignment metadata is unchanged.
  if (availabilityRanking) {
    const weekly = isWorkerAvailableForShift(worker, shift,
      shift?.timeZone || shift?.timezone || facility?.timeZone || facility?.timezone);
    score += weekly === true ? 3 : weekly === false ? -3 : 0;
    reasons.push(weekly === true ? "Available for this shift" :
      weekly === false ? "Unavailable for this shift" : "Availability unknown");
    const status = String(worker.availabilityStatus || "").trim().toLowerCase();
    const quick = { off_today: [-8, "Off Today"], vacation: [-16, "Vacation"], sick: [-16, "Sick"] }[status];
    if (quick) {
      score += quick[0];
      reasons.push(`Quick Status: ${quick[1]}`);
    }
  }

  return {
    score: Math.min(100, Math.round(score)),
    reasons,
  };
}